import {pageTitleStyles} from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPageTitle";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

pageTitleStyles.brandGridItem={
    width: 12,
    css:css`
    a[data-test-selector="brandLink"] {
        width: auto
       };
    `,
}



